import { Component, type ErrorInfo, type ReactNode } from "react";
import { staleChunkRecovery } from "@/lib/staleChunkRecovery";
import { ErrorFallbackContent } from "./ErrorFallbackContent";

type Props = {
	children: ReactNode;
	fallback?: ReactNode;
};

type State = {
	hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		// A lazy chunk outside the router lands here, not on the route fallback, so it recovers here too.
		if (staleChunkRecovery.maybeRecoverChunkCrash(error)) {
			return;
		}
		console.error("ErrorBoundary caught:", error, info.componentStack);
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback ?? <ErrorFallbackContent />;
		}
		return this.props.children;
	}
}
